// removed by extract-text-webpack-plugin
module.exports = {"title":"nUASj","header":"_1qkOk","headerLogin":"xyyMy","headerHome":"QNaRd _1qkOk","headerAlbum":"_3enRQ _1qkOk","headerAlbumEdit":"_3XHvi _1qkOk","headerPlaylists":"pubCt _1qkOk","headerQueues":"_1Ouym _1qkOk","headerChannels":"_11Sgl _1qkOk","icon":"_1J9If","backIcon":"_2pC1r _1J9If"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header.css
// module id = 803
// module chunks = 0